import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  width: 175px;
  height: 90px;
  box-sizing: border-box;

  position: absolute;
  font-family: Sora;
  background: #444;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
  margin-bottom: 20px;

  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: ${(props) => (props.isAbove ? "-27px" : "auto")};
    top: ${(props) => (props.isAbove ? "auto" : "-27px")};
    left: ${(props) => props.markPosition || "calc(50% - 14px)"};
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-top: 14px solid
      ${(props) => (props.isAbove ? "#444" : "transparent")};
    border-bottom: 14px solid
      ${(props) => (props.isAbove ? "transparent" : "#444")};
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ColorDot = styled.div`
  width: 15px;
  height: 15px;
  border: 1px solid black;
  background: ${(props) =>
    props.color.includes("gradient") ? `url(${props.color})` : props.color};
  cursor: pointer;
`;
